import React from 'react';
import * as Icons from "../common/Icons";
import { Link } from "react-router-dom";

const UpperNav = () => {
  return (
    <div className="w-full py-5 upper-nav md:block hidden">
      <div className="flex items-center md:justify-between justify-center 2xl:container mx-auto lg:px-16 px-5">
        <Link to="/">
          <div className="flex items-center gap-4 text-white fill-current">
            <Icons.BackIcon />
            <p className="text-white font-raleway text-2xl">Back</p>
          </div>
        </Link>
        <Link to="/">
          <img src="/logo.png" alt="Visiosol" className="brand-logo" />
        </Link>
        <div className="md:block hidden">
          <div className="flex items-center gap-4">
            <Icons.PhoneIcon />
            <div className="flex flex-col">
              <a
                href="tel:+923335274666"
                className="2xl:text-2xl xl:text-xl text-base font-raleway font-bold text-white"
              >
                +92 333 5274666
              </a>
              <a
                href="mailto:info@visiosol.tech"
                className="2xl:text-2xl xl:text-xl text-base font-raleway font-normal text-white"
              >
                info@visiosol.tech
              </a>
              <a
                href="https://wa.me/923335274666?text=Hello%20Visiosol%2C%20I%27d%20like%20to%20discuss%20a%20project%20with%20your%20team."
                target="_blank"
                rel="noreferrer"
                className="2xl:text-xl xl:text-lg text-sm font-raleway font-normal text-white"
              >
                WhatsApp: +92 333 5274666
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpperNav;
